<template>
  <div
    class="absolute left-0 right-0 pt-0 mx-4 overflow-auto text-white border-0 pointer-events-none captions bottom-24 lg_left-8 lg_right-8 rounded-2xl"
    :class="containerClasses"
  >
    <div
      class="flex-col captions-text-container captions-text"
      :class="[show && transitionStage !== 'expired' ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none']"
      @click.self="$emit('click', $event)"
    >
      <slot />
    </div>
    <DeckCaptionsGradient :show="show" :caption="caption" :class="[show && transitionStage !== 'expired' ? 'opacity-100' : 'opacity-0']" />
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  caption: {
    type: String as PropType<string | null>,
    default: null,
  },
  transitionStage: {
    type: String,
    default: null,
  },
  hideOnMobile: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['click'])

const containerClasses = computed(() => {
  return [
    { 'z-10 show pointer-events-auto': props.show && props.transitionStage !== 'expired', 'hidden sm_flex': props.hideOnMobile },
    'max-h-1/4 h-auto',
    'w-fit md_max-w-3/4 xl_max-w-1/2',
  ]
})
</script>

<style lang="stylus" scoped>
.captions
  @apply transition-all duration-500 ease-in-out
  @apply text-sm xl2_text-base flex-col
  word-break: break-word

  .captions-text-container
    @apply flex relative overflow-auto max-h-full h-full bg-gray-900 bg-opacity-90 p-4
    @apply delay-100 transition-all duration-300
    scrollbar-width: none
    -ms-overflow-style: none

  .captions-text
    @apply opacity-0 transition-all duration-500 ease-in-out
    @apply text-white font-medium decoration-clone w-full

  &.show .captions-text
    @apply opacity-100

  &.no-transition .captions-text
    @apply transition-none

// hide scrollbar
::-webkit-scrollbar
  display: none

// transition for the close button and its enclosing container
.fade-enter-active, .fade-leave-active,
.fade-enter, .fade-leave-to
  &.no-transition
    @apply transition-none
</style>
